import { v4 as uuidv4 } from 'uuid';
// import ProjectImg from '../images/projectImg.png';
// import UTrackerImg from '../images/utracker.jpg';
// import GreenCtgImg from '../images/greenctg.jpg';
import CoinTrackerImg from '../images/cointracker.jpg';
// import CavinImg from '../images/cavinimg.jpg';
import neflix from '../images/netflix-front.png';
import portfolio from '../images/portfolio-front.png';
import tictactoe from '../images/tictactoe.png';
import restapi from '../images/rest_api.png';
import one from '../images/1.png';
import covid from '../images/covid.png';
import sorting from '../images/sorting.png';
import wordhunt from '../images/wordhunt.png';

const projects = [
  {
    id: uuidv4(),
    name: "Soneja's Shop",
    desc:
      'A fully functional Ecommerce Website with payment, admin , user and cart panel',
    img: one,
    link: 'https://soneja-store.onrender.com/',
    git: 'https://github.com/sagar-soneja/SONEJA-SHOP-WEBSITE',
  },
  {
    id: uuidv4(),
    name: 'Sorting Visualization',
    desc:
      'Visualization for Various Sorting Algorithms for getting better understanding.',
    img: sorting,
    link: 'https://sorting-ss.netlify.app/',
    git: 'https://sorting-ss.netlify.app/',
  },
  {
    id: uuidv4(),
    name: 'Word Hunt',
    desc:
      'Dictionary PWA made using ReactJs. Supports 10+ languages, uses Axios for API calls.',
    img: wordhunt,
    link: 'https://word-hunt-ss.netlify.app/',
    git: 'https://word-hunt-ss.netlify.app/',
  },
  {
    id: uuidv4(),
    name: 'Covid Dashboard',
    desc:
      'Covid Dashboard which utilizes various api to generate charts to shows insights from data.',
    img: covid,
    link: 'https://covid-dashboard-ss.netlify.app',
    git: 'https://github.com/sagar-soneja/Covid-Dashboard',
  },

  {
    id: uuidv4(),
    name: 'Task Manager Rest API',
    desc:
      'A Task Manager Rest API which we can use to create and store users and their tasks with authentication.',
    img: restapi,
    link: 'https://github.com/sagar-soneja/API-TaskManager',
    git: 'https://github.com/sagar-soneja/API-TaskManager',
  },
  {
    id: uuidv4(),
    name: 'PortFolio Website',
    desc:
      'A web application made with Reactjs to show my projects, achievement and my work',
    img: portfolio,
    link: 'https://sagar-portfolio-ss.netlify.app/',
    git: 'https://github.com/sagar-soneja/Portfolio-Website/',
  },
  {
    id: uuidv4(),
    name: 'Netflix Clone',
    desc:
      'A clone of Netflix UI made using Reactjs and TMDB Api. It fetch data from TMDB database',
    img: neflix,
    link: 'https://netflix-clone-ss.netlify.app/',
    git: 'https://github.com/sagar-soneja/Netflix-Clone/',
  },
  {
    id: uuidv4(),
    name: 'Github Clone',
    desc:
      'A clone of Github made using Reactjs and Github api, provide basic functionality ',
    img: CoinTrackerImg,
    link: 'https://github-app-ss.netlify.app/',
    git: 'https://github.com/sagar-soneja/Gihub-Search-Web-App/',
  },
  {
    id: uuidv4(),
    name: 'Tic Tac Toe',
    desc:
      'A simple Tic Tac Toe game made using reactjs, react-icons, reactstrap, bootstrap',
    img: tictactoe,
    link: 'https://tic-tac-toe-ss.netlify.app/',
    git: 'https://github.com/sagar-soneja/Tic-Tac-Toe/',
  },
];

export default projects;
